import { createSlice } from '@reduxjs/toolkit';

import { getAllCustomerApi } from './customerApi';

// ----------------------------------------------------------------------

const initialState = {
  isCustomerLoading: false,
  customerList: [],
  categoryList: []
};

const slice = createSlice({
  name: 'customer',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllCustomerApi.pending]: (state) => {
      state.isCustomerLoading = true;
    },
    [getAllCustomerApi.fulfilled]: (state, action) => {
      state.customerList = action.payload;
      state.isCustomerLoading = false;
    },
    [getAllCustomerApi.rejected]: (state) => {
      state.isCustomerLoading = false;
    }
  }
});
export const customerActions = slice.actions;

export default slice.reducer;
